var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"screen"},[_c('div',{staticClass:"message"},[_vm._v(" Thank you! We will be in touch soon!")]),_vm._v(" "),_c('div',{staticClass:"tab"},[_c('div',{staticClass:"page-title"},[_vm._v("Apointments")]),_vm._v(" "),_c('hr')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d7abd12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scheduled.vue
// module id = null
// module chunks = 